export default function Collage5Module(element) {
    let tl = gsap.timeline({
        scrollTrigger: { trigger:element, end: 'top 500px' }
    });

    element.querySelectorAll('.collage5__item').forEach(function(item, index) {
        // let movement = gsap.utils.random(20, 50);
        // item.style.setProperty('--maxtop', movement + 'px');
        // item.classList.add('floating');

        let fromY = (window.innerWidth + (index * 200));
        tl.from(item, {y: fromY, duration: 3}, '<')
    });

    return this;
}

